import { render, staticRenderFns } from "./dropdown-item.vue?vue&type=template&id=1c5f2cbe"
import script from "./dropdown-item.vue?vue&type=script&lang=js"
export * from "./dropdown-item.vue?vue&type=script&lang=js"
import style0 from "./dropdown-item.vue?vue&type=style&index=0&id=1c5f2cbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports